function hotspotFunctions() {
	// variables
	var $slideDOM = $('#' + globalVar.curSlide);
	var slideID = globalVar.curSlide;
	var $hotspots = $slideDOM.find(' .hotspot-button');
	var $modalBlocker = $slideDOM.find('.hotspot-modal-blocker');
	var $modals = $modalBlocker.find(' .hotspot-modal');
	var $modalClose = $modalBlocker.find('.modal-close');

	var clickChecker = {};

	var slideObj = slides[globalVar.curSlide];
	var settings = slideObj.hotspot || {};

	var selectedClass;
	var activeClass = settings.activeClass || 'active-hotspot';
	var correctClass = settings.correctClass || 'correct';
	var modalStyleClass = settings.modalStyleClass || 'modal-style';
	var hotspotStyleClass = settings.hotspotStyleClass || 'hotspot-style';
	var completeAction = settings.customCompleteAction || slideObj.nextAction;

	settings.activeClass = activeClass;
	settings.correctClass = correctClass;
	settings.selectedClass = selectedClass;
	settings.modalStyleClass = modalStyleClass;
	settings.hotspotStyleClass = hotspotStyleClass;

	settings.clickChecker = clickChecker;
	settings.indv = settings.indv || {};

	$hotspots.addClass(hotspotStyleClass);
	$hotspots.each(function (i, spot) {
		$(spot).addClass(hotspotStyleClass + '-' + (i + 1));
	});

	$modals.addClass(modalStyleClass);
	$modals.each(function (i, mod) {
		$(mod).addClass(modalStyleClass + '-' + (i + 1));
	});

	if (settings.correctHotspots)
		settings.correctHotspots.forEach(function (item) {
			$($hotspots[item - 1]).addClass(correctClass);
		});

	// build clickChecker object
	for (var i = 0; i < $hotspots.length; i++) {
		clickChecker[i + 1] = clickChecker[i + 1] || {};
		clickChecker[i + 1].seen = false;

		//if correctClass specified add correctClass key
		if (settings.correctClass) {
			var correctClass = settings.correctClass;
			clickChecker[i + 1].hasCorrectClass = $($hotspots[i]).hasClass(correctClass);
		} else {
			clickChecker[i + 1].hasCorrectClass = true;
		}
	}

	// if (!settings.audioSetup)
	// 	for (var key in settings.audio) {
	// 		settings.audio[key] = new Howl({
	// 			src: [settings.audio[key]]
	// 		});
	// 		settings.audioSetup = true;
	// 	}

	if (settings.linear) {
		if (settings.quiz) throw '\nHotspot Error:\nyou cannot use "linear" and "quiz" together';
		if (settings.correctHotspots) throw '\nHotspot Error:\nyou cannot use "linear" and "correctHotspots" together';
		$hotspots.removeClass(activeClass);
		lock($hotspots);
		unlock($($hotspots[0]));
		$($hotspots[0]).addClass(activeClass);
	} else if (settings.quiz) {
		selectedClass = settings.quiz.selectedClass || 'selected-hotspot';
		$hotspots.removeClass(selectedClass);
		settings.quiz.selectedAnswers = [];
		settings.useModals = false;
	}

	$hotspots.each(function (i, hoSp) {
		var $thisHotspot = $(hoSp);
		//event listener for hotspots
		if (settings.hover === true) {
			$thisHotspot.off('mouseover.hotspot');
			$thisHotspot.on('mouseover.hotspot', function () {
				handleHotspot(i, hoSp);
			});
			$modalBlocker.addClass('hover-spot');
		} else {
			$thisHotspot.off('click.hotspot');
			$thisHotspot.on('click.hotspot', function () {
				handleHotspot(i, hoSp);
			});
		}
	});

	function handleHotspot(i, hoSp) {
		var mainOnClick = settings.onClick;
		var indvOnClick = settings.indv[i + 1] && settings.indv[i + 1].onClick;
		var $thisModalClose = $($modalClose[i]);
		var $thisModal = $($modals[i]);
		var $thisHotspot = $(hoSp);
		var modalWarn = "you haven't created a modal for this hotspot";
		// console.log($thisModal.add($thisModalClose));
		mainOnClick && mainOnClick(hoSp, $modals[i] || modalWarn);
		indvOnClick && indvOnClick(hoSp, $modals[i] || modalWarn);

		if (settings.audio && Object.keys(settings.audio).length > 0) {
			// console.log('hotspot audio found', siAudio[slideID][i + 1]);

			Howler.stop();
			for (var key in settings.audio) siAudio[slideID][key].stop();
			siAudio[slideID][i + 1] && siAudio[slideID][i + 1].play();
		}

		if (settings.quiz) {
			if (settings.quiz.type === 'scq') $hotspots.removeClass(selectedClass);
			$thisHotspot.toggleClass(selectedClass);
			settings.quiz.selectedAnswers = [];
			$hotspots.each(function (idx, quizHotspot) {
				if ($(quizHotspot).hasClass(selectedClass)) settings.quiz.selectedAnswers.push(idx + 1);
			});
		} else if (settings.useModals === false) {
			clickChecker[i + 1].seen = true;
			allSeenBehavior();

			if (settings.linear === true) unlockNextHotspot($hotspots[i + 1], settings.indv[i + 2]);
		} else {
			$modalBlocker.show();
			$thisModal.show();

			function handleClose(e) {
				var mainOnModalClose = settings.onModalClose;
				var indvOnModalClose = settings.indv[i + 1] && settings.indv[i + 1].onModalClose;

				settings.audio && settings.audio[i + 1] && siAudio[slideID][i + 1].stop();
				// settings.audio && settings.audio[i + 1] && settings.audio[i + 1].stop();
				clickChecker[i + 1].seen = true;

				$thisModal.hide();
				$modalBlocker.hide();

				mainOnModalClose && mainOnModalClose(hoSp, $modals[i] || modalWarn);
				indvOnModalClose && indvOnModalClose(hoSp, $modals[i] || modalWarn);

				allSeenBehavior();

				if (settings.linear === true) unlockNextHotspot($hotspots[i + 1], settings.indv[i + 2]);
			}
			// console.log($($modals[i], $modalClose));
			$thisModal.add($thisModalClose).off('click.stpr');
			$thisModal.add($thisModalClose).on('click.stpr', function (e) {
				e.stopPropagation();
			});
			$modalBlocker.add($thisModalClose).off('click.modal-blocker');
			$modalBlocker.add($thisModalClose).on('click.modal-blocker', handleClose);
			if (settings.hover === true) {
				$hotspots.each(function (i, hoSp) {
					$thisHotspot.off('mouseout.hotspot');
					$thisHotspot.on('mouseout.hotspot', handleClose);
				});
			}
		}
	}

	//check for completion and define what happens
	function allSeenBehavior() {
		if (allSeen(clickChecker)) completeAction();
	}

	function allSeen(clickChecker) {
		var result = true;

		for (var item in clickChecker) {
			if (clickChecker[item].seen === false && !clickChecker[item].hasCorrectClass) {
				result = false;
				break;
			}
		}
		return result;
	}

	function unlockNextHotspot(nextHotspot, nextHotspotSettings) {
		var mainOnUnlock = settings.onUnlock;
		var indvOnUnlock = nextHotspotSettings && nextHotspotSettings.onUnlock;

		$hotspots.removeClass(activeClass);

		unlock($(nextHotspot));
		$(nextHotspot).addClass(activeClass);

		mainOnUnlock && mainOnUnlock(nextHotspot);
		indvOnUnlock && indvOnUnlock(nextHotspot);
	}
}

function resetHotspot() {
	hotspotFunctions();
}
